import { BasicStore } from '@bridebook/web/app-basic/lib/types';
import { IUISupplierWithMarker } from '@bridebook/web/lib/types';
import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';

const getSearch = (state: BasicStore) => state.search;
const getSearchBarInfo = (state: BasicStore) => state.searchBarInfo;

export const getSearchList = createSelector(getSearch, ({ list }) => list);
export const getHasSearchListResults = createSelector(getSearchList, (list) => !!list.length);
export const getTotalResults = createSelector(getSearch, ({ totalResults }) => totalResults);
export const getActualCategory = createSelector(getSearch, ({ actualCategory }) => actualCategory);
export const getSearchFields = createSelector(getSearch, ({ fields }) => fields);
export const getSearchParams = createSelector(getSearch, ({ fields }) => fields?.searchParams);
export const getFacetsContent = createSelector(getSearch, ({ facetsContent }) => facetsContent);
export const getFAQContent = createSelector(getSearch, ({ faqContent }) => faqContent);
export const getSearchWidgets = createSelector(getSearch, ({ searchWidgets }) => searchWidgets);
export const getRelatedAreas = createSelector(getSearch, ({ relatedAreas }) => relatedAreas);
export const getAreaFacets = createSelector(getSearch, ({ areaFacets }) => areaFacets);
export const getIsSearchListLoaded = createSelector(getSearch, ({ loaded }) => loaded);
export const getSearchLocationCounty = createSelector(
  getSearchFields,
  (fields) => fields?.addressComponents?.administrative_area_level_2,
);
export const getSearchArea = createSelector(getSearchFields, (fields) => fields?.area);
export const getSearchFilters = createSelector(getSearch, ({ filters }) => filters);
export const getSearchFiltersItem = createCachedSelector(
  getSearchFilters,
  (_: BasicStore, key: string) => key,
  (filters, key) => filters[key],
)((_: BasicStore, key: string) => key);

export const getSearchSource = createSelector(getSearchBarInfo, ({ source }) => source);
export const getSearchBounds = createSelector(getSearchBarInfo, ({ bounds }) => bounds);

export const getSearchMarkers = createSelector(getSearchList, (list) =>
  list.filter((s): s is IUISupplierWithMarker => !!s.lat && !!s.lng),
);

export const getSelectedMarkerId = createSelector(
  getSearch,
  ({ selectedMarkerId }) => selectedMarkerId,
);
export const getHighlightedMarkerId = createSelector(
  getSearch,
  ({ highlightedMarkerId }) => highlightedMarkerId,
);
